import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  params, string, shape, number, extend, useDataModel, arrayOf
} from '@thd-nucleus/data-sources';
import { DrawerHeader } from '@one-thd/sui-atomic-components';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';
import { MiniPip } from '../../common/mini-pip/MiniPip';

// Screen title mapping
const SCREEN_TITLES = {
  [SCREENS.MINI_PIP_PRODUCT_REVIEWS]: 'Reviews',
  [SCREENS.MINI_PIP_PRODUCT_SPECS]: 'Specifications',
  [SCREENS.MINI_PIP_PRODUCT_OVERVIEW]: 'Overview',
  [SCREENS.MINI_PIP_BASE]: 'Item Details',
};

export const DisplayItemDetails = (props) => {
  const {
    products
  } = props;

  const {
    addToType,
    storeId,
    setScreen,
    screen,
    handleClose,
    selectedProductDetails,
  } = useContext(AddToContext);
  const {
    MINI_PIP_BASE,
    MINI_PIP_PRODUCT_OVERVIEW,
    MINI_PIP_PRODUCT_SPECS,
    MINI_PIP_PRODUCT_REVIEWS
  } = SCREENS;
  const itemId = selectedProductDetails?.itemId || products?.[0]?.itemId;

  useEffect(() => {
    if (products?.length >= 1) {
      setScreen(MINI_PIP_BASE);
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('AddToListDrawer.ready');
    } else {
      handleClose('close');
    }
  }, []);

  const handleBackPress = () => {
    // eslint-disable-next-line max-len
    if (screen === MINI_PIP_PRODUCT_OVERVIEW || screen === MINI_PIP_PRODUCT_SPECS || screen === MINI_PIP_PRODUCT_REVIEWS) {
      setScreen(MINI_PIP_BASE);
    }
  };

  const showBackButton = (
    (screen === MINI_PIP_PRODUCT_OVERVIEW)
        || (screen === MINI_PIP_PRODUCT_SPECS)
        || (screen === MINI_PIP_PRODUCT_REVIEWS)
  );

  return (
    <>
      <DrawerHeader
        data-testid="add-to-drawer-header"
        title={SCREEN_TITLES[screen] || 'Display Item Details'}
        onClose={() => handleClose('close')}
        onBack={showBackButton ? handleBackPress : null}
      />
      {itemId && (
        <MiniPip
          itemId={itemId}
          isDisplayOnly
          hideSalientPoints
        />
      )}
    </>
  );
};

DisplayItemDetails.displayName = 'DisplayItemDetails';

DisplayItemDetails.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    itemId: PropTypes.string,
    quantity: PropTypes.number
  }))
};

DisplayItemDetails.defaultProps = {
  products: []
};

DisplayItemDetails.dataModel = extend(
  {
    product: params({ itemId: string().isRequired(), dataSource: string() }).shape({
      itemId: string(),
      dataSource: string(),
      dataSources: string(),
      pricing: params({ storeId: string() }).shape({
        value: number({ float: true })
      }),
      identifiers: shape({
        brandName: string(),
        productLabel: string()
      }),
      media: shape({
        images: arrayOf(shape({
          url: string(),
          type: string(),
          subType: string()
        }))
      })
    })
  },
);
